define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isPasswordValid = exports.isUsernameValid = void 0;
    var isUsernameValid = function (username) {
        return username.length >= 4;
    };
    exports.isUsernameValid = isUsernameValid;
    var isPasswordValid = function (password) {
        return password.length >= 8;
    };
    exports.isPasswordValid = isPasswordValid;
});
